
import React, { Component } from 'react';
import TextField from '../TextField';
import CheckBox from '../CheckBox';
import DropdownMaster from '../DropdownMaster';
import DropDown from '../Dropdown';
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { ActCreators } from '../../redux/bindActionCretor'
import { PAF_TYPES } from '../../cosntants'
import service from '../../services'
import FpgPlusIcon from './../../icons/fpgplusicon';
import FpgMinusIcon from './../../icons/fpgminusicon'
import SimpleReactValidator from 'simple-react-validator';
import { isNumber } from 'lodash';
import { STATE_PRO } from '../../cosntants';
import Select from 'react-dropdown-select';
import MultiSelect from '../MultiSelect';
import Loader from '../loader';
import ConflictSaveModal from '../ConflictSaveModal';

let sub;

const mapStateToProps = state => ({
    PostAcceptanceEditListId: state.PostAcceptanceEditListId,
    countries: state.countries,
    recordConflict: state.recordConflict,
})

const mapDispatchToProps = dispatch => {
    return bindActionCreators(ActCreators, dispatch)
};
class ProjectContact extends Component {
    constructor(props) {
        super(props)
        this.state={
            loading: false,
            showConflictModal: false,
            isProjectContactEdited: false,
            projectUserId: this.props.PostAcceptanceEditListId,
            userInfo: {
                composer: {},
                distributor: {},
                editor: {},
                salesAgent: [],
                cinematographer: '',
                credits:[],
                mainPublicityContacts: {
                    address1: '',
                    address2: '',
                    city: '',
                    company: '',
                    country: '',
                    email: '',
                    firstName: '',
                    lastName: '',
                    middleName: '',
                    phoneNumber: '',
                    state: '',
                    title: '',
                    type: '',
                    zipCode: ''
                },
                mainContacts: {
                    address1: '',
                    address2: '',
                    city: '',
                    company: '',
                    country: '',
                    email: '',
                    firstName: '',
                    middleName: '',
                    phoneNumber: '',
                    state: '',
                    title: '',
                    type: '',
                    zipCode: ''
                },
                techContact:{
                    firstName: '',
                    middleName: '',
                    lastName: '',
                    title:'',
                    email: '',
                    phoneNumber: '',
                    type: ''
                }  ,
                userData:{
                    email: "",
                    fname: "",
                    lname: "",
                    mname: "",
                    primaryPhone: ""
                },
                userId :{
                    email: "",
                    fname: "",
                    lname: "",
                    mname: "",
                    primaryPhone: ""
                }
            },
            origins:[
                {id:'01', name: "africanAmerican", label: "Black, African American or of African descent", value: false },
                // {id:'02', name: 'AmericanIndian', label: 'American Indian, Alaskan Native, or Indigenous', value: false },
                {id:'03', name: "nativeAmerican", label: "Native American or First Nations or Indigenous", value: false },
                {id:'04', name: 'EastAsian', label: 'East Asian', value: false },
                {id:'05', name: 'SouthAsian', label: 'South Asian', value: false },
                // {id:'06', name: 'NativeHawaiian', label: 'Native Hawaiian', value: false },
                {id:'07', name: 'SoutheastAsian', label: 'Southeast Asian', value: false },
                {id:'08', name: "whiteEuropean", label: "White, European, or of European descent", value: false },
                {id:'09', name: 'Hispaniclati', label: 'Hispanic, Latino/a, Latinx, Latine', value: false },
                {id:'10', name: "middleEastern", label: "Middle Eastern", value: false },
                {id:'11', name: "pacificIslanderorHawaiian", label: "Pacific Islander and/or Native Hawaiian", value: false },
                // {id:'12', name: "biRacialMultiRacial", label: "Bi-racial or Multi-Racial", value: false },
                {id:'13', name: "other", label: "Other", value: false },
                {id:'14', name: "declineToState", label: "Decline to State", value: false }],
            AllDropData: [],
            primaryPhoneType : ["Mobile", "Office", "Other"],
            countries : this.props.countries,
            states: ['Alabama', 'Alaska', 'Arizona', 'Arkansas', 'California', 'Colorado', 'Connecticut', 'Dist. Columbia', 'Delaware', 'Florida', 'Georgia', 'Hawaii', 'Idaho', 'Illinois', 'Indiana', 'Iowa', 'Kansas', 'Kentucky', 'Louisiana', 'Maine', 'Maryland', 'Massachusetts', 'Michigan', 'Minnesota', 'Mississippi', 'Missouri', 'Montana', 'Nebraska', 'Nevada', 'New Hampshire', 'New Jersey', 'New Mexico', 'New York', 'North Carolina', 'North Dakota', 'Ohio', 'Oklahoma', 'Oregon', 'Pennsylvania', 'Rhode Island', 'South Carolina', 'South Dakota', 'Tennessee', 'Texas', 'Utah', 'Vermont', 'Virginia', 'Washington', 'West Virginia', 'Wisconsin', 'Wyoming', 'Alberta', 'British Columbia', 'Labrador', 'Manitoba', 'New Brunswick', 'Newfoundland', 'Nova Scotia', 'Nunavut', 'North West Terr', 'Ontario', 'Prince Edward Is', 'Quebec', 'Saskatchewen', 'Yukon'],
            distributionTypes:['International','Domestic','Both'],
            previwId:''
        
        }
        this.validator = new SimpleReactValidator({ autoForceUpdate: this });        
        this.apiserve = new service(); 
    };

    markProjectContactEdited = () => {
        if (!this.state.isProjectContactEdited) {
            this.setState({ isProjectContactEdited: true });
        }
    }

    updateState = (state) => {
        this.setState(state);
        this.markProjectContactEdited();
    }
 
    componentWillUnmount = () => {
        if(sub) {
            sub.unsubscribe();
        }
    }

    componentDidMount(){
      
        if(this.state.projectUserId){
            this.apiserve.sendevent("paf|project|getDetail", {});
            this.apiserve.sendevent("paf|project|getProjectInfo", { id:this.state.projectUserId });
        }
        this.getAllDetails();
    };

    // componentWillUnmount = () => {
    //     this.submitContactForm()
    //     sub.unsubscribe();
    //   }
    cancelFn = () =>{
     
        this.props.history.push('/paf-projectlist');
    
 }
 salesAgent = (e) => {
    let salesAgent = this.state.userInfo.salesAgent;
    var newAdded = {
        address1:"",
        address2: "",
        city: "",
        company: "",
        country: "",
        email: "",
        firstName: "",
        lastName: "",
        middleName: "",
        distributionType:'',
        phoneNumber: "",
        state: "",
        title: "",
        type: "",
        zipCode: "",
        _id: (new Date().getTime() + Math.floor(Math.random() * 100)).toString(),
    }
    salesAgent.push(newAdded);
    this.updateState({ ...this.state, userInfo: { ...this.state.userInfo, salesAgent: salesAgent} })
}

moveObjectAtIndex = (array, sourceIndex, destIndex) => {
    var placeholder = {};
    // remove the object from its initial position and
    // plant the placeholder object in its place to
    // keep the array length constant
    var objectToMove = array.splice(sourceIndex, 1, placeholder)[0];
    // place the object in the desired position
    array.splice(destIndex, 0, objectToMove);
    // take out the temporary object
    array.splice(array.indexOf(placeholder), 1);
    return array
}

removesalesAgent = (e, id) => {
    const salesAgent =  this.state.userInfo.salesAgent.filter(item => item._id != id)
    this.updateState({
        ...this.state,
        userInfo:{
            ...this.state.userInfo,
            salesAgent: salesAgent
        }
        
    })

}

    getAllDetails(){
        sub = this.apiserve.getevent().subscribe((response) => {
            switch (response.event) {
                case "paf|project|getProjectInfo":
                    if(!response.error){
                        // var ContactInfo = JSON.parse(JSON.stringify(response.data));
                        var ContactInfo = response.data;

                        let castIndex = ContactInfo.credits.findIndex(element => element.identifier === 'principalcast')
                        let creditLastIndex = ContactInfo.credits.length 
                        
                        this.setState({
                            userdata: ContactInfo,
                            userInfo: {
                                mediaId: ContactInfo.mediaId ? ContactInfo.mediaId : '',
                                fileMakerId: ContactInfo.fileMakerId ? ContactInfo.fileMakerId : '',
                                title:ContactInfo.title,
                                pafType: ContactInfo.pafType,
                                article:ContactInfo.article,
                                category:ContactInfo.category,
                                credits: this.moveObjectAtIndex(ContactInfo.credits, castIndex ,creditLastIndex), 
                                mainPublicityContacts: ContactInfo.mainPublicityContacts,
                                mainContacts: ContactInfo.mainContacts,
                                techContact: ContactInfo.techContact,
                                filmProjectType: ContactInfo.filmProjectType,
                                englishPhoneticProdununciation: ContactInfo.englishPhoneticProdununciation,
                                composer:ContactInfo.composer,
                                userId:ContactInfo.userId,
                                distributor:ContactInfo.distributor,
                                editor:ContactInfo.editor,
                                salesAgent:ContactInfo.salesAgent.length > 0 ? ContactInfo.salesAgent : [{
                                    address1: "",
                                    address2: "",
                                    city: "",
                                    company: "",
                                    country: "",
                                    email: "",
                                    firstName: "",
                                    lastName: "",
                                    middleName: "",
                                    distributionType:"",
                                    phoneNumber: "",
                                    state: "",
                                    title: "",
                                    type: "",
                                    zipCode: "",
                                    _id: (new Date().getTime() + Math.floor(Math.random() * 100)).toString(),
                                }],
                                cinematographer:ContactInfo.cinematographer,
                                projectInfo: {
                                    soundFormat: response.data.projectInfo.soundFormat,
                                    premiereStatus: response.data.projectInfo.premiereStatus,
                                    yearFinished: response.data.projectInfo.yearFinished,
                                    inPersonFormat: response.data.projectInfo.inPersonFormat,
                                    onlineFormat: response.data.projectInfo.onlineFormat,
                                    aspectRatio: response.data.projectInfo.aspectRatio,
                                    color: response.data.projectInfo.color,
                                    language: response.data.projectInfo.language,
                                    subtitles: response.data.projectInfo.subtitles,
                                    finalRunTime: response.data.projectInfo.finalRunTime,
                                    runTime: response.data.projectInfo.runTime,
                                    includeStroboscopicImg: response.data.projectInfo.includeStroboscopicImg,
                                    timecodeOccursInProject: response.data.projectInfo.timecodeOccursInProject,
                                    captionAudioInDCP: response.data.projectInfo.captionAudioInDCP,

                                },
                                digitalMedia: {
                                    officialWebsite: response.data.digitalMedia.officialWebsite,
                                    youtubeOrVimeoTrailer: response.data.digitalMedia.youtubeOrVimeoTrailer,
                                    instagram: response.data.digitalMedia.instagram,
                                    facebook: response.data.digitalMedia.facebook,
                                    twitter: response.data.digitalMedia.twitter,
                                    hastag: response.data.digitalMedia.hastag,
                                },
                                publicContact: {
                                    firstName: response.data.publicContact.firstName,
                                    middleName: response.data.publicContact.middleName,
                                    lastName: response.data.publicContact.lastName,
                                    company: response.data.publicContact.company,
                                    publicEmail: response.data.publicContact.publicEmail,
                                    website: response.data.publicContact.website,
                                    phoneNumber: response.data.publicContact.phoneNumber,
                                    type: response.data.publicContact.type,
                                },
                                postFestivalContact: {
                                    firstName: response.data.postFestivalContact.firstName,
                                    middleName: response.data.postFestivalContact.middleName,
                                    lastName: response.data.postFestivalContact.lastName,
                                    company: response.data.postFestivalContact.company,
                                    publicEmail: response.data.postFestivalContact.publicEmail,
                                    website: response.data.postFestivalContact.website,
                                    phoneNumber: response.data.postFestivalContact.phoneNumber,
                                    type: response.data.postFestivalContact.type,
                                },
                                countryOfOrigin: ContactInfo.countryOfOrigin,
                                category: ContactInfo.category,
                                filmCategoryData: ContactInfo.filmCategoryData,
                                synopsis: ContactInfo.synopsis,
                                images: ContactInfo.images.length === 0 ? [{ _id: Math.random().toString(), link: "", inSite: "" }, { _id: Math.random().toString(), link: "", inSite: "" }, { _id: Math.random().toString(), link: "", inSite: "" }] : ContactInfo.images,

                            }
                        })
                    }else{
                        this.setState({ errorPopup:true, errorMsg: response.data.error ? response.data.error : response.data })
                    }
                    break;

                    case "paf|project|getDetail":
                    if(!response.error) {
                        this.setState({ AllDropData: response.data }) }
                    else this.apiserve.error(response.data.error)
                    break;
                    case "paf|project|updateSecondPage":
                        this.setState({loading: false})
                        if(!response.error)
                        {
                            this.setState({loading: false, btnDisable:false, isProjectContactEdited: false})
                            this.apiserve.success("Updated successfully.!");
                            return;
                        }
                        else this.apiserve.error(response.data.error)
                        break;
                    case "tempStorage|create":
                        if (!response.error) {
                            this.setState({
                                previwId:response?.data?._id,
                                loading: false,
                                btnDisable: false
                            })
                            window.open(process.env.REACT_APP_FRONTEND_ORIGIN_PAF + `Preview/paf-preview?data=${response?.data?._id}`);
                        }
                        else this.apiserve.error(response.data.error)
                        break;
                    default:
                        break;
            }
        });
    };

    getContactDetails = (HEADER, half, cred) => {
        const { userInfo } = this.state;
        return (
            <div>
                <h3 className="ps_contactsubtitle mb_10 uppercase">{HEADER}</h3>
                <div className="d_flex">
                    <div className="field_row horizontal_field mr_10">
                        <TextField label="First Name" name='firstName' value={cred.firstName} onChange={(e) => this.meetthehandleChange(e, half, cred._id)} maxLength={100} />
                    </div>
                    <div className="field_row horizontal_field mr_10">
                        <TextField label="Middle Name" name='middleName' value={cred.middleName} onChange={(e) => this.meetthehandleChange(e, half, cred._id)} />
                    </div>
                    <div className="field_row horizontal_field mr_10">
                        <TextField label="Last Name" name='lastName' value={cred.lastName} onChange={(e) => this.meetthehandleChange(e, half, cred._id)} maxLength={100} />
                    </div>
                    <div className="field_row horizontal_field">
                        <TextField label="Email" name='email' value={cred.creditDetails?.email} onChange={(e) => this.meetthehandleChange(e, half, cred._id)} maxLength={255} />
                    </div>
                </div>

                <div className="d_flex">
                    <div className="field_row horizontal_field mr_10">
                        <TextField label="Company" name='company' value={cred.creditDetails?.company} onChange={(e) => this.meetthehandleChange(e, half, cred._id)} />
                    </div>
                    <div className="field_row horizontal_field mr_10">
                        <TextField label="Title" name='title' value={cred.creditDetails?.title} onChange={(e) => this.meetthehandleChange(e, half, cred._id)} />
                    </div>
                    <div className="field_row horizontal_field mr_10">
                        <TextField type="number" label="Phone" name='phoneNumber' value={cred.creditDetails?.phoneNumber} onChange={(e) => this.meetthehandleChange(e, half, cred._id)} />
                    </div>
                    <div className="field_row horizontal_field">
                        <DropDown label="Phone Type" options={this.state.primaryPhoneType} name='type' value={cred.creditDetails?.type} onChange={(e) => this.meetthehandleChange(e, half, cred._id)} DefaultOption={'Select From Below'}/>
                    </div>
                </div>

                <div className="field_row horizontal_field ps_address_field mr_10">
                    <TextField label="Street Address 1" name='address1' value={cred.creditDetails?.address1} onChange={(e) => this.meetthehandleChange(e, half, cred._id)} />
                </div>

                <div className="field_row horizontal_field ps_address_field mr_10">
                    <TextField label="Street Address 2" name='address2' value={cred.creditDetails?.address2} onChange={(e) => this.meetthehandleChange(e, half, cred._id)} />
                </div>

                {/* <div className="d_flex">
                    <div className="field_row horizontal_field mr_10">
                        <TextField label="City" name='city' value={cred.creditDetails?.city} onChange={(e) => this.meetthehandleChange(e, half, cred._id)} />
                    </div>
                    <div className="field_row horizontal_field mr_10">
                        <DropDown label="State/Territory/ Province" name='state' options={ this.state.states } value={cred.creditDetails?.state} onChange={(e) => this.meetthehandleChange(e, half, cred._id)} DefaultOption={'Select From Below'}/>
                    </div>
                    <div className="field_row horizontal_field mr_10">
                        <TextField label="Zip" name='zipCode' value={cred.creditDetails?.zipCode} onChange={(e) => this.meetthehandleChange(e, half, cred._id)} />
                    </div>
                    <div className="field_row horizontal_field ">
                        <DropDown label="Country" options={ this.state.countries } name='country' value={cred.creditDetails?.country} onChange={(e) => this.meetthehandleChange(e, half, cred._id)} DefaultOption={'Select From Below'} />
                    </div>
                    
                </div> */}
                {HEADER.includes('SALES', 'AGENT', 'CONTACT') ?
                <>
                <div className="d_flex">
                    <div className="field_row horizontal_field mr_10">
                        <TextField label="City" name='city' value={cred.creditDetails?.city} onChange={(e) => this.meetthehandleChange(e, half, cred._id)} />
                    </div>
                    <div className="field_row horizontal_field mr_10">
                    <DropDown   options={ this.state.states} name="state" onChange={(e) => this.meetthehandleChange(e, half, cred._id)} value={cred.creditDetails?.state}  label="State/Territory/ Province" DefaultOption={'Select State/Province'} uppercase />
                    {/* {cred.creditDetails?.country === 'United States' || cred.creditDetails?.country=== 'Canada' ?
                    <DropDown   options={ this.state.states} name="state" onChange={(e) => this.meetthehandleChange(e, half, cred._id)} value={cred.creditDetails?.state}  label="State/Territory/ Province" DefaultOption={'Select State/Province'} uppercase /> :
                    <TextField   type="text" name="state" onChange={(e) => this.meetthehandleChange(e, half, cred._id)} value={cred.creditDetails?.state} label="State/Territory/ Province" uppercase />} */}
                        
                    </div>
                    <div className="field_row horizontal_field mr_10">
                        <TextField label="Zip" name='zipCode' value={cred.creditDetails?.zipCode} onChange={(e) => this.meetthehandleChange(e, half, cred._id)} />
                    </div>
                    <div className="field_row horizontal_field ">
                        <DropDown label="Country" options={ this.state.counries } name='country' value={cred.creditDetails?.country} onChange={(e) => this.meetthehandleChange(e, half, cred._id)} DefaultOption={'Select From Below'} />
                    </div>
                    <div className="field_row horizontal_field ">
                        <DropDown label="Type of Sales" options={ this.state.distributionTypes } name='distributionType' value={cred.creditDetails?.distributionType} onChange={(e) => this.meetthehandleChange(e, half, cred._id)} DefaultOption={'Select From Below'} />
                    </div>
                    
                </div>
                </> :
                <>
                <div className="d_flex">
                    <div className="field_row horizontal_field mr_10">
                        <TextField label="City" name='city' value={cred.creditDetails?.city} onChange={(e) => this.meetthehandleChange(e, half, cred._id)} />
                    </div>
                    <div className="field_row horizontal_field mr_10">
                    <DropDown   options={ this.state.states} name="state" onChange={(e) => this.meetthehandleChange(e, half, cred._id)} value={cred.creditDetails?.state}  label="State/Territory/ Province" DefaultOption={'Select State/Province'} uppercase /> 
                    {/* {cred.creditDetails?.country === 'United States' || cred.creditDetails?.country=== 'Canada' ?
                    <DropDown   options={ this.state.states} name="state" onChange={(e) => this.meetthehandleChange(e, half, cred._id)} value={cred.creditDetails?.state}  label="State/Territory/ Province" DefaultOption={'Select State/Province'} uppercase /> :
                    <TextField   type="text" name="state" onChange={(e) => this.meetthehandleChange(e, half, cred._id)} value={cred.creditDetails?.state} label="State/Territory/ Province" uppercase />} */}
                        
                    </div>
                    <div className="field_row horizontal_field mr_10">
                        <TextField label="Zip" name='zipCode' value={cred.creditDetails?.zipCode} onChange={(e) => this.meetthehandleChange(e, half, cred._id)} />
                    </div>
                    <div className="field_row horizontal_field ">
                        <DropDown label="Country" options={ this.state.countries } name='country' value={cred.creditDetails?.country} onChange={(e) => this.meetthehandleChange(e, half, cred._id)} DefaultOption={'Select From Below'} />
                    </div>
                    
                </div>
                </>}
                <div className="field_row">
                    <label className="border_btm_1 mb_15 pb_15"></label>
                </div>
            </div>

        )
    };

    getPublicityContact = (HEADER, callFor) => {
        const { userInfo } = this.state;  
        return (
            <div>
                <h3 className="ps_contactsubtitle mb_10 uppercase">{ HEADER }</h3>
                <div className="d_flex">
                    <div className="field_row horizontal_field mr_10">
                        <TextField label="First Name" name='firstName' value={userInfo[callFor]?.firstName} onChange={(e) => this.handlePublicityContact(e, callFor)} maxLength={100} />
                    </div>
                    <div className="field_row horizontal_field mr_10">
                        <TextField label="Middle Name" name='middleName' value={userInfo[callFor]?.middleName} onChange={(e) => this.handlePublicityContact(e, callFor)} />
                    </div>
                    <div className="field_row horizontal_field mr_10">
                        <TextField label="Last Name" name='lastName' value={userInfo[callFor]?.lastName} onChange={(e) => this.handlePublicityContact(e, callFor)} maxLength={100} />
                    </div>
                    <div className="field_row horizontal_field">
                        <TextField label="Email" name='email' value={userInfo[callFor]?.email} onChange={(e) => this.handlePublicityContact(e, callFor)} maxLength={255} />
                    </div>
                </div>


                <div className="d_flex">
                    <div className="field_row horizontal_field mr_10">
                        <TextField label="Company" name='company' value={userInfo[callFor]?.company} onChange={(e) => this.handlePublicityContact(e, callFor)} />
                    </div>
                    <div className="field_row horizontal_field mr_10">
                        <TextField label="Title" name='title' value={userInfo[callFor]?.title} onChange={(e) => this.handlePublicityContact(e, callFor)} />
                    </div>
                    <div className="field_row horizontal_field mr_10">
                        <TextField type="number" label="Phone" name='phoneNumber' value={userInfo[callFor]?.phoneNumber} onChange={(e) => this.handlePublicityContact(e, callFor)} />
                    </div>
                    <div className="field_row horizontal_field">
                        <DropDown label="Phone Type" options={this.state.primaryPhoneType} name='type' value={userInfo[callFor]?.type} onChange={(e) => this.handlePublicityContact(e, callFor)} DefaultOption={'Select From Below'} />
                    </div>
                </div>

                <div className="field_row horizontal_field ps_address_field mr_10">
                    <TextField label="Street Address 1" name='address1' value={userInfo[callFor]?.address1} onChange={(e) => this.handlePublicityContact(e, callFor)} />
                </div>

                <div className="field_row horizontal_field ps_address_field mr_10">
                    <TextField label="Street Address 2" name='address2' value={userInfo[callFor]?.address2} onChange={(e) => this.handlePublicityContact(e, callFor)} />
                </div>

                <div className="d_flex">
                    <div className="field_row horizontal_field mr_10">
                        <TextField label="City" name='city' value={userInfo[callFor]?.city} onChange={(e) => this.handlePublicityContact(e, callFor)} />
                    </div>
                    <div className="field_row horizontal_field mr_10">
                    <DropDown   options={STATE_PRO} name="state" onChange={(e) => this.handlePublicityContact(e, callFor)} value={userInfo[callFor]?.state}  label="State/Territory/ Province" DefaultOption={'Select State/Province'} uppercase /> 
                        {/* <DropDown label="State/Territory/ Province" options={ this.state.states } name='state' value={userInfo[callFor]?.state} onChange={(e) => this.handlePublicityContact(e, callFor)} DefaultOption={'Select From Below'} /> */}
                        {/* <DropDown   options={STATE_PRO} name="state" onChange={(e) => this.handlePublicityContact(e, callFor)} value={userInfo[callFor]?.state}  label="State/Territory/ Province" DefaultOption={'Select State/Province'} uppercase /> :
                        {userInfo[callFor]?.country === 'United States' || userInfo[callFor]?.country === 'Canada' ?
                    <TextField   type="text" name="state" onChange={(e) => this.handlePublicityContact(e, callFor)} value={userInfo[callFor]?.state} label="State/Territory/ Province" uppercase />} */}
                    </div>
                    <div className="field_row horizontal_field mr_10">
                        <TextField label="Zip" name='zipCode' value={userInfo[callFor]?.zipCode} onChange={(e) => this.handlePublicityContact(e, callFor)} />
                    </div>
                    <div className="field_row horizontal_field ">
                        <DropDown label="Country" options={ this.state.countries } name='country' value={userInfo[callFor]?.country} onChange={(e) => this.handlePublicityContact(e, callFor)} DefaultOption={'Select From Below'} />
                    </div>
                </div>

                <div className="field_row">
                    <label className="border_btm_1 mb_15 pb_15"></label>
                </div>
            </div>
        )
    };
    getAdditionalCreditContact = (HEADER, callFor, sales, id, i) => {
        const { userInfo } = this.state;  
        return (
            <div>
                <div className="d_flex">
                <h3 className="ps_contactsubtitle mb_10 uppercase mr_10">{ HEADER }</h3> 
                 {callFor=== 'salesAgent' && 
                 <>
                    <>
                        { i === 0 &&  <span style={{ cursor:  this.state.userInfo.salesAgent.length === 3 ? 'not-allowed' : 'pointer' }} className="pointer mr_5" onClick={(e) => this.state.userInfo.salesAgent.length <=2 ? this.salesAgent(e) : ''}> <FpgPlusIcon className="pointer" width="20" height="20" color="#4F4F4F" stroke="#fff" /></span>}
                    </>
                    <>
                        { i === 1 && <span style={{ cursor:  this.state.userInfo.salesAgent.length ===3 ? 'not-allowed' : 'pointer' }} className="pointer mr_5" onClick={(e) => this.state.userInfo.salesAgent.length <=2 ? this.salesAgent(e) : ''}> <FpgPlusIcon className="pointer" width="20" height="20" color="#4F4F4F" stroke="#fff" /></span> }
                        { i >= 1 && <span className="pointer" onClick={(e) => this.removesalesAgent(e, id)}> <FpgMinusIcon className="pointer" width="20" height="20" color="#4F4F4F" stroke="#fff" /></span> }
                    </>
                </>
                }
                      
                </div>
                <div className="d_flex">
                    <div className="field_row horizontal_field mr_10">
                        <TextField label="First Name" name='firstName' value={callFor === 'salesAgent' ? sales.firstName : userInfo[callFor]?.firstName} onChange={(e) => this.handleAdditionalCreditContact(e, callFor,id)} maxLength={100} />
                    </div>
                    <div className="field_row horizontal_field mr_10">
                        <TextField label="Middle Name" name='middleName' value={callFor === 'salesAgent' ? sales.middleName : userInfo[callFor]?.middleName} onChange={(e) => this.handleAdditionalCreditContact(e, callFor,id)} />
                    </div>
                    <div className="field_row horizontal_field mr_10">
                        <TextField label="Last Name" name='lastName' value={callFor === 'salesAgent' ? sales.lastName : userInfo[callFor]?.lastName} onChange={(e) => this.handleAdditionalCreditContact(e, callFor,id)} maxLength={100} />
                    </div>
                    <div className="field_row horizontal_field">
                        <TextField label="Email" name='email' value={callFor === 'salesAgent' ? sales.email : userInfo[callFor]?.email} onChange={(e) => this.handleAdditionalCreditContact(e, callFor,id)} maxLength={255} />
                    </div>
                </div>


                <div className="d_flex">
                    <div className="field_row horizontal_field mr_10">
                        <TextField label="Company" name='company' value={callFor === 'salesAgent' ? sales.company : userInfo[callFor]?.company} onChange={(e) => this.handleAdditionalCreditContact(e, callFor,id)} />
                    </div>
                    <div className="field_row horizontal_field mr_10">
                        <TextField type="number" label="Phone" name='phoneNumber' value={callFor === 'salesAgent' ? sales.phoneNumber : userInfo[callFor]?.phoneNumber} onChange={(e) => this.handleAdditionalCreditContact(e, callFor,id)} />
                    </div>
                    <div className="field_row horizontal_field">
                        <DropDown label="Phone Type" options={this.state.primaryPhoneType} name='type' value={callFor === 'salesAgent' ? sales.type : userInfo[callFor]?.type} onChange={(e) => this.handleAdditionalCreditContact(e, callFor,id)} DefaultOption={'Select From Below'}/>
                    </div>
                </div>

                <div className="field_row horizontal_field ps_address_field mr_10">
                    <TextField label="Street Address 1" name='address1' value={callFor === 'salesAgent' ? sales.address1 : userInfo[callFor]?.address1} onChange={(e) => this.handleAdditionalCreditContact(e, callFor,id)} />
                </div>

                <div className="field_row horizontal_field ps_address_field mr_10">
                    <TextField label="Street Address 2" name='address2' value={callFor === 'salesAgent' ? sales.address2 : userInfo[callFor]?.address2} onChange={(e) => this.handleAdditionalCreditContact(e, callFor,id)} />
                </div>

                <div className="d_flex">
                    <div className="field_row horizontal_field mr_10">
                        <TextField label="City" name='city' value={callFor === 'salesAgent' ? sales.city : userInfo[callFor]?.city} onChange={(e) => this.handleAdditionalCreditContact(e, callFor,id)} />
                    </div>
                    <div className="field_row horizontal_field mr_10">
                    <DropDown   options={STATE_PRO} name="state"  value={callFor === 'salesAgent' ? sales.state : userInfo[callFor]?.state} onChange={(e) => this.handleAdditionalCreditContact(e, callFor,id)}  label="State/Territory/ Province" DefaultOption={'Select State/Province'} uppercase /> 
                        {/* <DropDown label="State/Territory/ Province" options={ this.state.states } name='state' value={callFor === 'salesAgent' ? sales.state : userInfo[callFor]?.state} onChange={(e) => this.handleAdditionalCreditContact(e, callFor,id)} DefaultOption={'Select From Below'} /> */}
                        {/* { (callFor === 'salesAgent' ? sales.country :  userInfo[callFor]?.country )=== 'United States' || ( callFor === 'salesAgent' ? sales.country :  userInfo[callFor]?.country) === 'Canada' ?
                    <DropDown   options={STATE_PRO} name="state"  value={callFor === 'salesAgent' ? sales.state : userInfo[callFor]?.state} onChange={(e) => this.handleAdditionalCreditContact(e, callFor,id)}  label="State/Territory/ Province" DefaultOption={'Select State/Province'} uppercase /> :
                    <TextField   type="text" name="state"  value={callFor === 'salesAgent' ? sales.state : userInfo[callFor]?.state} onChange={(e) => this.handleAdditionalCreditContact(e, callFor,id)} label="State/Territory/ Province" uppercase />} */}
                    </div>
                    <div className="field_row horizontal_field mr_10">
                        <TextField label="Zip" name='zipCode' value={callFor === 'salesAgent' ? sales.zipCode : userInfo[callFor]?.zipCode} onChange={(e) => this.handleAdditionalCreditContact(e, callFor,id)} />
                    </div>
                    <div className="field_row horizontal_field ">
                        <DropDown label="Country" options={ this.state.countries } name='country' value={callFor === 'salesAgent' ? sales.country : userInfo[callFor]?.country} onChange={(e) => this.handleAdditionalCreditContact(e, callFor,id)} DefaultOption={'Select From Below'}/>
                    </div>
                    
                    {callFor === 'salesAgent' &&     <div className="field_row horizontal_field ">
                        <DropDown label="Type of Sales" options={this.state.distributionTypes} name='distributionType' value={callFor === 'salesAgent' ? sales.distributionType : userInfo[callFor]?.distributionType} onChange={(e) => this.handleAdditionalCreditContact(e, callFor, id)} DefaultOption={'Select From Below'} />
                    </div>}
                </div>

                <div className="field_row">
                    <label className="border_btm_1 mb_15 pb_15"></label>
                </div>
            </div>
        )
    };
    getfilmFreeSubmitterContact = (HEADER) => {
        const { userInfo } = this.state;  
        return (
            <div>
                <h3 className="ps_contactsubtitle mb_10 uppercase">{ HEADER }</h3>
                <div className="d_flex">
                    <div className="field_row horizontal_field mr_10">
                        <TextField label="First Name" name='fname' value={ userInfo?.userId?.fname } onChange={(e) => this.handlefilmFreeSubmitterContact(e)} maxLength={100} />
                    </div>
                    <div className="field_row horizontal_field mr_10">
                        <TextField label="Middle Name" name='mname' value={ userInfo?.userId?.mname} onChange={(e) => this.handlefilmFreeSubmitterContact(e)} />
                    </div>
                    <div className="field_row horizontal_field mr_10">
                        <TextField label="Last Name" name='lname' value={userInfo?.userId?.lname} onChange={(e) => this.handlefilmFreeSubmitterContact(e)} maxLength={100} />
                    </div>
                   
                </div>


                <div className="d_flex">
                    <div className="field_row horizontal_field mr_10">
                        <TextField label="Email" disable ={true} name='email' value={ userInfo?.userId?.email} onChange={(e) => this.handlefilmFreeSubmitterContact(e)} maxLength={255} />
                    </div>
                    <div className="field_row horizontal_field mr_10">
                        <TextField type="number" label="Phone" name='primaryPhone' value={userInfo?.userId?.primaryPhone} onChange={(e) => this.handlefilmFreeSubmitterContact(e)} />
                    </div>
                    {/* <div  className="field_row horizontal_field mr_10">
                        <DropDown disable={true} label="Phone Type" options={this.state.primaryPhoneType} name='type' value={userInfo.userData.type} onChange={(e) => this.handlefilmFreeSubmitterContact(e)} DefaultOption={'Select From Below'}/>
                    </div> */}
                </div>

                <div className="field_row">
                    <label className="border_btm_1 mb_15 pb_15"></label>
                </div>
            </div>
        )
    };
    getDcpTechContact = (HEADER) => {

        const { userInfo } = this.state;

        return (
            <div>
                <h3 className="ps_contactsubtitle mb_10 uppercase">{ HEADER }</h3>
                <div className="d_flex">
                    <div className="field_row horizontal_field mr_10">
                        <TextField label="First Name" name='firstName' value={userInfo?.techContact?.firstName} onChange={this.techContacthandleChange} maxLength={100} />
                    </div>
                    <div className="field_row horizontal_field mr_10">
                        <TextField label="Middle Name" name='middleName' value={userInfo?.techContact?.middleName} onChange={this.techContacthandleChange} />
                    </div>
                    <div className="field_row horizontal_field mr_10">
                        <TextField label="Last Name" name='lastName' value={userInfo?.techContact?.lastName} onChange={this.techContacthandleChange} maxLength={100} />
                    </div>
                    <div className="field_row horizontal_field mr_10">
                        <TextField label="Title (Affiliation to Film/Project)" name='title' value={userInfo?.techContact?.title} onChange={this.techContacthandleChange} />
                    </div>
                    <div className="field_row horizontal_field">
                        <TextField label="Email" name='email' value={userInfo?.techContact?.email} onChange={this.techContacthandleChange} maxLength={255} />
                    </div>
                </div>

                <div className="d_flex">
                    <div className="field_row horizontal_field mr_10">
                        <TextField label="Phone" name='phoneNumber' value={userInfo?.techContact?.phoneNumber} onChange={this.techContacthandleChange} />
                    </div>
                    <div className="field_row horizontal_field">
                        <DropDown label="Phone Type" options={this.state.primaryPhoneType} name='type' value={userInfo?.techContact?.type} onChange={this.techContacthandleChange} DefaultOption={'Select From Below'} />
                    </div>
                </div>

                <div className="field_row">
                    <label className="border_btm_1 mb_15 pb_15"></label>
                </div>
            </div> 
        )
    };

    handlePublicityContact = (e, callFor) => {
        if (e.target.value === "Select From Below")  e.target.value = "";
        const { name, value } = e.target;
        if(callFor === 'mainContacts'){
                if(name === 'country'){

                    this.updateState({ ...this.state, userInfo: { ...this.state.userInfo, mainContacts: { ...this.state.userInfo.mainContacts, [name]: value, state :'' }} })
                } else {
                    this.updateState({ ...this.state, userInfo: { ...this.state.userInfo, mainContacts: { ...this.state.userInfo.mainContacts, [name]: value,}} })
                }
        }
        else if(name === 'country'){

            this.updateState({ ...this.state, userInfo: { ...this.state.userInfo, mainPublicityContacts: { ...this.state.userInfo.mainPublicityContacts, [name]: value , state :''}} })
        } else{
            this.updateState({ ...this.state, userInfo: { ...this.state.userInfo, mainPublicityContacts: { ...this.state.userInfo.mainPublicityContacts, [name]: value }} })
        }
    };

    handleAdditionalCreditContact = (e, callFor,ID) => {
        if (e.target.value === "Select From Below")  e.target.value = "";
        const { name, value } = e.target;
        if(callFor === 'composer'){
            if(name === 'country'){

                this.updateState({ ...this.state, userInfo: { ...this.state.userInfo, composer: { ...this.state.userInfo.composer, [name]: value, state :'' }} })
            } else {
                this.updateState({ ...this.state, userInfo: { ...this.state.userInfo, composer: { ...this.state.userInfo.composer, [name]: value,}} })
            }
        }
        else if (callFor === 'distributor'){
            if(name === 'country'){

                this.updateState({ ...this.state, userInfo: { ...this.state.userInfo, distributor: { ...this.state.userInfo.distributor, [name]: value, state :'' }} })
            } else {
                this.updateState({ ...this.state, userInfo: { ...this.state.userInfo, distributor: { ...this.state.userInfo.distributor, [name]: value,}} })
            }
        }
        else if (callFor === 'editor'){
            if(name === 'country'){

                this.updateState({ ...this.state, userInfo: { ...this.state.userInfo, editor: { ...this.state.userInfo.editor, [name]: value, state :'' }} })
            } else {
                this.updateState({ ...this.state, userInfo: { ...this.state.userInfo, editor: { ...this.state.userInfo.editor, [name]: value,}} })
            }

        }           
        else if (callFor === 'cinematographer'){
            if(name === 'country'){

                this.updateState({ ...this.state, userInfo: { ...this.state.userInfo, cinematographer: { ...this.state.userInfo.cinematographer, [name]: value, state :'' }} })
            } else {
                this.updateState({ ...this.state, userInfo: { ...this.state.userInfo, cinematographer: { ...this.state.userInfo.cinematographer, [name]: value,}} })
            }

        }
        else if (callFor === 'salesAgent'){
            let salesA = this.state.userInfo.salesAgent
            salesA.forEach(data=>{
                if (data._id === ID) {
                    if(name === 'country'){
                        data[name] = value
                        data.state = ''
                    }else data[name] = value
                }
            })
            this.updateState({ ...this.state, userInfo: { ...this.state.userInfo, salesAgent: salesA} })}
    };


    handlefilmFreeSubmitterContact = (e) => {
        if (e.target.value === "Select From Below")  e.target.value = "";
        const { name, value } = e.target;
          this.updateState({
            userInfo: {
              ...this.state.userInfo,
              userId: {
                ...this.state.userInfo.userId,
                [name]: value,
              },
            //   userId:this.state.userInfo.userId
            },
          });
    };
    
    techContacthandleChange = (e) => {
        if (e.target.value === "Select From Below")  e.target.value = "";
        const { name, value } = e.target;
          this.updateState({
            userInfo: {
              ...this.state.userInfo,
              techContact: {
                ...this.state.userInfo.techContact,
                [name]: value,
              },
            },
          });
    };

    meetthehandleChange = (e,CID,IID, NAME) => {
        if (NAME === 'personWithDisability') {
            this.state.userInfo.credits.forEach(credit => {
                if (credit._id === CID) {
                    credit.creditType.forEach(data => {
                        if (data._id === IID) {
                            data.creditDetails.personWithDisability = e
                        }
                    })
                }
            })
        this.markProjectContactEdited()
        this.forceUpdate()
        } else {
        const { name, value } = e.target
        this.state.userInfo.credits.forEach(credit => {
                if (credit._id === CID) {
                    credit.creditType.forEach(data => {
                        if (data._id === IID) {
                            if(name === "firstName" || name === "middleName" || name === "lastName"){
                                data[name] = value
                            }else if(name === 'country'){
                                data.creditDetails[name] = value
                                data.creditDetails.state = ''
                            }else {
                                data.creditDetails[name] = value
                            }
                        }
                    })
                }
            });}
        this.markProjectContactEdited()
        this.forceUpdate()

    };

    handleCMAChange = (e,CID,IID) => {
        const { name, checked } = e.target;
        this.state.userInfo.credits.forEach(credit => {
            if (credit._id === CID) {
                credit.creditType.forEach(data => {
                    if (data._id === IID) {
                        data.creditDetails[name] = checked
                    }
                })
            }
        });
        this.setState({})
    };

    handleCheckAllOrigins = (e,CID,IID) => {
        let allOrigins = ["africanAmerican", "nativeAmerican", "EastAsian", "SouthAsian", "pacificIslanderorHawaiian", "SoutheastAsian", "whiteEuropean", "Hispaniclati", "other", "declineToState","middleEastern"];
        this.state.userInfo.credits.forEach(credit => {
            if (credit._id === CID) {
                credit.creditType.forEach(data => {
                    if (data._id === IID) {
                        allOrigins.forEach(origin => {
                            data.creditDetails[origin] = true
                        });
                    }
                })
            }
        });
        this.setState({})
    };
                              
    submitContactForm = (e) => {
       if(e) e.preventDefault();
        if (this.props.recordConflict) {
            this.setState({ showConflictModal: true });
            return;
        }
        var AllData = this.state.userdata;
        var UpdatedData = this.state.userInfo;
        let DATA = {
            projectId : AllData._id,
            // mediaId: UpdatedData.mediaId ? UpdatedData.mediaId : '',
            fileMakerId: UpdatedData.fileMakerId ? UpdatedData.fileMakerId : '',
            title : UpdatedData.title,
            pafType : UpdatedData.pafType,
            article : UpdatedData.article,
            category : UpdatedData.category,
            credits : UpdatedData.credits,
            filmProjectType: UpdatedData.filmProjectType,
            mainPublicityContacts : UpdatedData.mainPublicityContacts,
            englishPhoneticProdununciation : UpdatedData.englishPhoneticProdununciation,
            mainContacts : UpdatedData.mainContacts,
            techContact : UpdatedData.techContact,
            salesAgent:UpdatedData.salesAgent,
            composer:UpdatedData.composer,
            distributor:UpdatedData.distributor,
            editor:UpdatedData.editor,
            cinematographer:UpdatedData.cinematographer,
            userData:UpdatedData.userId
        }
        this.setState({loading: true, btnDisable: true});
        this.apiserve.sendevent("paf|project|updateSecondPage", DATA );     
    };
    previewRecord = (e) => {
        e.preventDefault()
        var AllData = this.state.userdata;
        var UpdatedData = this.state.userInfo;
        let ProjectContact = {
            pafType : UpdatedData.pafType,
            englishPhoneticProdununciation: UpdatedData.englishPhoneticProdununciation,
            credits: UpdatedData.credits,
            filmProjectType: UpdatedData.filmProjectType,
            category: UpdatedData.category,
            article: UpdatedData.article,
            title: UpdatedData.title,
            synopsis: UpdatedData.synopsis,
            countryOfOrigin: UpdatedData.countryOfOrigin,
            projectInfo: UpdatedData.projectInfo,
            digitalMedia: UpdatedData.digitalMedia,
            publicContact: UpdatedData.publicContact,
            postFestivalContact: UpdatedData.postFestivalContact,
            projectId: UpdatedData.projectId,
            images: UpdatedData.images,
            // Contact Data
            fileMakerId: UpdatedData.fileMakerId ? UpdatedData.fileMakerId : '',
            pafType : UpdatedData.pafType,
            mainPublicityContacts : UpdatedData.mainPublicityContacts,
            mainContacts : UpdatedData.mainContacts,
            techContact : UpdatedData.techContact,
            // Project Internal
            mediaId: UpdatedData.mediaId ? UpdatedData.mediaId : '',
            studentScreening: UpdatedData.studentScreening,
            freeCommunityScreening: UpdatedData.freeCommunityScreening,
            historyOfFilm: UpdatedData.historyOfFilm,
            adobeProductUse: UpdatedData.adobeProductUse,
            stockFootage: UpdatedData.stockFootage,
            cameras: UpdatedData.cameras,
            cameraPurchaseOrRent: UpdatedData.cameraPurchaseOrRent,
            cameraAnamorphicOrSpecialLense: UpdatedData.cameraAnamorphicOrSpecialLense,
            useCameraLence: UpdatedData.useCameraLence,
            influencedCamera: UpdatedData.influencedCamera,
            softwareUsedToEdit: UpdatedData.softwareUsedToEdit,
            useAdobeProducts: UpdatedData.useAdobeProducts,
            useHardware: UpdatedData.useHardware,
            useOtherTechnologyHardware: UpdatedData.useOtherTechnologyHardware,
            realTimes3DTools: UpdatedData.realTimes3DTools,
            useStockFootage: UpdatedData.useStockFootage,
            fundingPlatform: UpdatedData.fundingPlatform,
            sharingDistribution: UpdatedData.sharingDistribution,
            hybridDistribution: UpdatedData.hybridDistribution,
            useDropbox: UpdatedData.useDropbox,
            brieflyExplain: UpdatedData.brieflyExplain
        }
        let previewRecordFilm = this.apiserve.encrypt(ProjectContact)
        this.setState({loading: true, btnDisable: true});
        this.apiserve.sendevent("tempStorage|create", {tempData:previewRecordFilm}); 
    }
      
  
    handleChange = (e) => {
        const { name, value } = e.target;
        console.log(name,'name',value);
        this.updateState({ userInfo:{ ...this.state.userInfo, [name]: value } })
    };

    render() {
        const { userInfo } = this.state;
        return (
            <>
                {this.state.loading ?  <Loader /> : ''}
                <form className="ps_contact_form">

                    <div className="d_flex">
                        <div className="tab_col create_left_col">
                                <div className="d_flex fpg_media_id d_flex_align_center mb_5">
                                    <div className="field_row horizontal_field paf_view_page ">
                                    <ul className="data_list ">
                                        <li className="d_flex">
                                           <label style={{width:"50px"}}>Media ID: </label>  <span id="id_text" className="ml_10" > {userInfo.mediaId}</span>
                                        </li>
                                    </ul>
                                        {/* <TextField type="text" name="fileMakerId" id="fileMakerId" label="Media ID:" value={userInfo.mediaId} onChange={this.handleChange} /> */}
                                    </div>
                                    <div className="field_row horizontal_field ml_10 ">
                                        <TextField type="text" name="fileMakerId" id="fileMakerId" label="Filemaker ID:" value={userInfo.fileMakerId} onChange={this.handleChange} />
                                    </div>
                                </div> 
                        </div>
                    </div>

                    <div className="text_center mb_25"><h2>Contacts</h2></div>

                    <div className="project_section">
                        <div className="paf_screening_info border_btm_1 pb_20">
                            <div className="d_flex d_flex_justify_end w_100 info_first_row">
                                    <div className="field_row horizontal_field ">
                                    </div>
                                    <div className="field_row horizontal_field ">
                                        <DropDown label="PAF Type " value={userInfo.pafType} disable={true} options={this.state.AllDropData.pafType} DefaultOption={'Select From Below'}/>
                                    </div>
                                    <div className="field_row horizontal_field ">
                                        <DropdownMaster label="Film/Project Category" value={userInfo.category} options={ this.state.AllDropData.filmCategoryData } name='category' onChange={this.handleChange} defaultValue={'Select From Below'} disable={userInfo.pafType === PAF_TYPES.NEW_FRONTIER} />
                                    </div>
                            </div> 

                            <div className="d_flex w_100 info_first_row d_flex_justify_end">
                                    <div className="field_row horizontal_field">
                                        <TextField value={userInfo.article} label="Article" name='article' onChange={this.handleChange} />
                                    </div>
                                    <div className="field_row horizontal_field">
                                        <TextField value={userInfo.title} label="Title" name='title' onChange={this.handleChange} />
                                    </div>
                                    <div className="field_row horizontal_field">
                                        <TextField value={userInfo.englishPhoneticProdununciation} label="English Phonentic Pronunciation" name='englishPhoneticProdununciation' onChange={this.handleChange} />
                                    </div>
                            </div>
                        </div>

                        <div className="pt_25 ps_contact">
                            <div className=""><h2 className="mb_15">Film Team - Private Contact Information</h2></div>

                            {/* MAIN PUBLICITY CONTACT */}
                            {this.getPublicityContact('MAIN CONTACT', 'mainContacts')}


                            {/* Public Contact */}
                            {this.getPublicityContact('MAIN PUBLICITY CONTACT', 'mainPublicityContacts')}


                            {/* DCP/Print or tech contact */}
                            {this.getDcpTechContact('Film/Project Tech & Delivery Contact')}
                            

                            {/* MEET THE ARTIST (Director / Lead Artist) / PANELIST 1 CONTACT */}
                            <div>
                                <h3 className="ps_contactsubtitle mb_10 uppercase">MEET THE ARTIST (Director / Lead Artist) / PANELIST 1 CONTACT</h3>
                                {userInfo?.credits?.map((item, i) => {
                                    let half = item._id
                                    return(
                                        <>
                                        {item.identifier === ( this.state.userInfo.pafType === PAF_TYPES.NEW_FRONTIER ? 'leadartist' : userInfo.credits[0].identifier) && 
                                            <>
                                            {item.creditType.map((cred, index) => {
                                                return(
                                                    <>                                                
                                                    <div className="d_flex" key={index}>
                                                        <div className="field_row horizontal_field mr_10">
                                                            <TextField label="First Name" name='firstName' value={cred.firstName} onChange={(e) => this.meetthehandleChange(e, half, cred._id)} maxLength={100} />
                                                        </div>
                                                        <div className="field_row horizontal_field mr_10">
                                                            <TextField label="Middle Name" name='middleName' value={cred.middleName} onChange={(e) => this.meetthehandleChange(e, half, cred._id)} />
                                                        </div>
                                                        <div className="field_row horizontal_field mr_10">
                                                            <TextField label="Last Name" name='lastName' value={cred.lastName} onChange={(e) => this.meetthehandleChange(e, half, cred._id)} maxLength={100} />
                                                        </div>
                                                        <div className="field_row horizontal_field">
                                                            <TextField label="English Phonetic Pronunciation" name='englishPhoneticProdununciation' value={cred.creditDetails.englishPhoneticProdununciation} onChange={(e) => this.meetthehandleChange(e, half, cred._id)} />
                                                        </div>
                                                    </div>


                                                    <div className="d_flex">
                                                        <div className="field_row horizontal_field mr_10">
                                                            <TextField label="Company" name='company' value={cred.creditDetails.company} onChange={(e) => this.meetthehandleChange(e, half, cred._id)} />
                                                        </div>
                                                        <div className="field_row horizontal_field mr_10">
                                                            <DropDown label="Pronouns" options={['He/Him','She/Her','They/Them','Other']} name='preferredPronouns' value={cred.creditDetails.preferredPronouns} onChange={(e) => this.meetthehandleChange(e, half, cred._id)}   DefaultOption={'Select From Below'}/>
                                                        </div>
                                                        <div className="field_row horizontal_field ">
                                                            <DropDown label="First Feature" options={['Yes', 'No']} value={cred.creditDetails.firstFeature} name='firstFeature' onChange={(e) => this.meetthehandleChange(e, half, cred._id)} DefaultOption={'Select From Below'} /> 
                                                        </div>
                                                    </div>


                                                    <div className="d_flex">
                                                        <div className="field_row horizontal_field mr_10">
                                                            <TextField label="Email" name='email' value={cred.creditDetails.email} onChange={(e) => this.meetthehandleChange(e, half, cred._id)} maxLength={255} />
                                                        </div>
                                                        <div className="field_row horizontal_field mr_10">
                                                            <TextField label="Phone" name='phoneNumber' value={cred.creditDetails.phoneNumber} onChange={(e) => this.meetthehandleChange(e, half, cred._id)} />
                                                        </div>
                                                        <div className="field_row horizontal_field mr_10">
                                                            <DropDown label="Phone Type" options={this.state.primaryPhoneType} value={cred.creditDetails.type} name='type' onChange={(e) => this.meetthehandleChange(e, half, cred._id)} DefaultOption={'Select From Below'} />
                                                        </div>
                                                    </div>


                                                    <div className="field_row horizontal_field ps_address_field mr_10">
                                                        <TextField label="Street Address 1" name='address1' value={cred.creditDetails.address1} onChange={(e) => this.meetthehandleChange(e, half, cred._id)} />
                                                    </div>
                                                    <div className="field_row horizontal_field ps_address_field mr_10">
                                                        <TextField label="Street Address 2" name='address2' value={cred.creditDetails.address2} onChange={(e) => this.meetthehandleChange(e, half, cred._id)} /> 
                                                    </div>


                                                    <div className="d_flex">
                                                        <div className="field_row horizontal_field mr_10">
                                                            <TextField label="City" name='city' value={cred.creditDetails.city} onChange={(e) => this.meetthehandleChange(e, half, cred._id)} /> 
                                                        </div>
                                                        <div className="field_row horizontal_field mr_10">
                                                        <DropDown label="State/Territory/ Province" name='state'  options={ this.state.states } value={cred.creditDetails.state} onChange={(e) => this.meetthehandleChange(e, half, cred._id)} DefaultOption={'Select From Below'} />
                                                             {/* {cred.creditDetails.country === 'United States' || cred.creditDetails.country === 'Canada' ? 
                                                            <DropDown label="State/Territory/ Province" name='state'  options={ this.state.states } value={cred.creditDetails.state} onChange={(e) => this.meetthehandleChange(e, half, cred._id)} DefaultOption={'Select From Below'} /> :
                                                            
                                                            <TextField label="State/Territory/ Province" name='state' value={cred.creditDetails.state} onChange={(e) => this.meetthehandleChange(e, half, cred._id)} /> 
                                                            } */}
                                                        </div>
                                                        <div className="field_row horizontal_field mr_10">
                                                            <TextField label="Zip" name='zipCode' value={cred.creditDetails.zipCode} onChange={(e) => this.meetthehandleChange(e, half, cred._id)} /> </div>
                                                        <div className="field_row horizontal_field mr_10">
                                                            <DropDown label="Country" options={this.state.countries} name='country' value={cred.creditDetails.country} onChange={(e) => this.meetthehandleChange(e, half, cred._id)} DefaultOption={'Select From Below'} /> 
                                                        </div>
                                                    </div>

                                                    <div className="d_flex">
                                                        <div className="field_row horizontal_field mr_10">
                                                            <DropDown label="Gender Expression" options={['Woman', 'Man', 'Non-Binary or Gender Non-conforming','Intersex', 'Other', 'Decline to State']} name='directorGenderExpression' value={cred.creditDetails.directorGenderExpression} onChange={(e) => this.meetthehandleChange(e, half, cred._id)} DefaultOption={'Select From Below'} />
                                                        </div>
                                                        <div className="field_row horizontal_field mr_10">
                                                            <DropDown label="Identify as Transgender" options={['Yes', 'No','Other', 'Decline to State']} name='directorIdentifyTransgender' value={cred.creditDetails.directorIdentifyTransgender} onChange={(e) => this.meetthehandleChange(e, half, cred._id)} DefaultOption={'Select From Below'}/>
                                                        </div>
                                                        <div className="field_row horizontal_field mr_10">
                                                            <DropDown label="Sexual Orientation" options={['Heterosexual','Gay or Lesbian','Bisexual and/or Pansexual','Other','Decline to State']} name='sexualOrientation' value={cred.creditDetails.sexualOrientation} onChange={(e) => this.meetthehandleChange(e, half, cred._id)} DefaultOption={'Select From Below'}/>
                                                        </div>
                                                        <div className="field_row horizontal_field mr_10">
                                                            {/* <DropDown label="Person With A Disability" options={[{ label: 'Yes, Cognitive', value: 'Yes, Cognitive' }, { label: 'Yes, Emotional', value: 'Yes, Emotional' }, { label: 'Yes, Hearing', value: 'Yes, Hearing' }, { label: 'Yes, Visual', value: 'Yes, Visual' }, { label: 'Yes, Sensory (non-vision/hearing)', value: 'Yes, Sensory (non-vision/hearing)' }, { label: 'Yes, Mental', value: 'Yes, Mental' }, { label: 'Yes, Physical', value: 'Yes, Physical' }, { label: 'No', value: 'No' }, { label: 'Other', value: 'Other' }, { label: 'Decline to State', value: 'Decline to State' }]} name='personWithDisability' value={cred.creditDetails.personWithDisability} onChange={(e) => this.meetthehandleChange(e, half, cred._id)} DefaultOption={'Select From Below'}/> */}
                                                            <MultiSelect label="Person With A Disability" options={[{ label: 'Autism/ Neurodivergent', value: 'Autism/ Neurodivergent' }, { label: 'Blind or low vision', value: 'Blind or low vision' }, { label: 'Cognitive disability', value: 'Cognitive disability' }, { label: 'Chronic illness / pain', value: 'Chronic illness / pain' }, { label: 'D/Deaf or hard of hearing', value: 'D/Deaf or hard of hearing' }, { label: 'Developmental disability', value: 'Developmental disability' }, { label: 'Learning / Behavioral disability', value: 'Learning / Behavioral disability' }, { label: 'Mental health condition', value: 'Mental health condition' }, { label: 'Physical disability', value: 'Physical disability' }, { label: 'Speech-related disability', value: 'Speech-related disability' }, { label: 'Other / Prefer to describe', value: 'Other / Prefer to describe' }, { label: 'Prefer not to say', value: 'Prefer not to say' }]} name='personWithDisability' value={cred.creditDetails.personWithDisability} onChange={this.meetthehandleChange} half = {half} cred = {cred._id} DefaultOption={'Select From Below'}/>
                                                        </div>
                                                        <div className="field_row horizontal_field mr_10">
                                                            <DropDown label="Birth Country" options={this.state.countries} value={cred.creditDetails.directorBornCountry} name='directorBornCountry' onChange={(e) => this.meetthehandleChange(e, half, cred._id)} DefaultOption={'Select From Below'}/>
                                                        </div>
                                                    </div>


                                                    <h3 className="ps_contactsubtitle mb_5">{"What is Director "+(index + 1)+"’s race and/or ethnic origin?"} </h3> 
                                                    <h4 className="ps_subtitle mb_15" onClick={(e) => this.handleCheckAllOrigins(e, half, cred._id)}>Check all that apply.</h4> 
                                                    <div className="d_flex ps_check_column">
                                                        {
                                                            
                                                            this.state.origins.length > 0 && this.state.origins.map((origin,index) => {
                                                                return(
                                                                    <CheckBox checked={cred.creditDetails[origin.name]? true : false} name={origin.name}  label={origin.label} type="checkbox" id={cred._id + origin.id} onChange={(e) => this.handleCMAChange(e, half, cred._id)}/>
                                                                )
                                                            })
                                                        }
                                                    </div>  
                                                    <div className="field_row"><label className="border_btm_1 mb_15 pb_15"></label></div>                                             


                                                </>
                                                )
                                            })}
                                            </>
                                        }
                                        </>
                                    )
                                })}
                            </div>    

                                {this.state.userInfo?.credits?.map((item, i) => {
                                    let half = item._id
                                    
                                    return(
                                        <>
                                        {item.identifier ===(this.state.userInfo.pafType === PAF_TYPES.NEW_FRONTIER ? 'keycollaborator' :  "screenwriter") &&  
                                            <>
                                            {item.creditType.map((cred, index) => {

                                                return(
                                                    this.getContactDetails(`SCREENWRITER / KEY COLLABORATOR / ADDITIONAL TOP CREDIT ${index + 1} CONTACT`, half, cred)
                                                )
                                            })}
                                            </>                                        
                                        }

                                        {item.identifier === "producer" && 
                                            <>
                                            {item.creditType.map((cred, index) => {
                                                return(
                                                    this.getContactDetails(`PRODUCER ${index + 1} CONTACT`, half, cred)
                                                )
                                            })}
                                            </>                                        
                                        }

                                        {/* {item.creditLabel === "Submitter Contact" && 
                                            <>
                                            {item.creditType.map((cred, index) => {
                                                return(
                                                    this.filmFreeSubmitterContact('FILMFREEWAY Submitter CONTACT', half, cred)
                                                )
                                            })}
                                            </>                                        
                                        } */}
                                        
                                        </>
                                    )
                                })}

                                {/* { this.getContactDetails(``, this.state.userInfo.composer)} */}

                                {this.getAdditionalCreditContact('COMPOSER CONTACT' , 'composer')}
                                {this.getAdditionalCreditContact('EDITOR CONTACT' , 'editor')}
                                {this.getAdditionalCreditContact('CINEMATOGRAPHER CONTACT' , 'cinematographer')}
                                {this.state.userInfo.salesAgent.map((sales,index) =>(
                                        this.getAdditionalCreditContact(`SALES AGENT ${index + 1} CONTACT`,'salesAgent', sales, sales._id, index)
                                ))}

                                {this.getAdditionalCreditContact('Distributor/ Gallery/ Institution' , 'distributor')} 

                                {this.getfilmFreeSubmitterContact('FilmFreeway Submitter Contact')}
                        </div>
                        
                        <div className="text_center field_row w_100 buttons_outer">
                            <button className="uppercase" type='button' onClick={()=>this.cancelFn()}>CANCEL</button>
                            <button className="uppercase prev_btn" type='button' onClick={(e)=>this.previewRecord(e)}>PREviEW</button>
                            <button disabled={this.state.loading || (this.state.projectUserId ? !this.state.isProjectContactEdited : false)} className={`uppercase ${ !(this.state.loading || (this.state.projectUserId ? !this.state.isProjectContactEdited : false)) ? 'active' : '' }`} type='button' onClick={(e)=>this.state.loading ? '' : this.submitContactForm(e)} >SAVE </button> 
                        </div>    
                    </div> 
                </form>   
            <ConflictSaveModal
                isVisible={this.state.showConflictModal}
                conflict={this.props.recordConflict}
                onClose={() => this.setState({ showConflictModal: false })}
            />
          </>
        )
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ProjectContact)
